<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.languageContent && localService.languageContent.table && items">
  <div class="banner center" style="max-width:500px;">
    <div class="row row_header freeze_height">
      <div class="col-4">
        <div style="float:left;">
          <a class="button" *ngIf="pageKeyAccessType == 2" [routerLink]="['/pagekeys' + localService.basicParamsString,1,0]"><i class="material-icons button icon_adjust">north</i></a>
        </div>
        {{localService.languageContent.table.action}}
      </div>
      <div class="col-8">
        {{localService.languageContent.table.title}}
        <span class="en" *ngIf="pageKey != 0">&nbsp;-&nbsp;{{strPageKey}}</span>
        <div class="icon_action_header" *ngIf="pageKeyAccessType == 1">
          <i class="material-icons button" (click)="onAction(2)">file_download</i>
          <app-file-upload [fileUploadFor]="FileUploadFor.AccessMapping"></app-file-upload>
        </div>
      </div>
    </div>
    <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
      <div class="row styled_row" *ngFor="let item of items">
        <div class="col-4">
          <a class="button" [routerLink]="['/allowed-actions' + localService.basicParamsString,pageKeyAccessType == 1 ? item.key : pageKey,pageKeyAccessType == 1 ? 0 : item.key]"><i class="material-icons button icon_adjust">security</i></a>
          <a class="button" *ngIf="pageKeyAccessType == 1" [routerLink]="['/pagekeys' + localService.basicParamsString,2,item.key]"><i class="material-icons button icon_adjust">account_tree</i></a>
          <i *ngIf="pageKeyAccessType == 1" class="material-icons button icon_adjust" (click)="onAction(1,item.key)">menu</i>
          <i *ngIf="pageKeyAccessType == 1" class="material-icons button icon_adjust" (click)="localService.showSummary(item.key,6)">help</i>
        </div>
        <div class="col-8">
          <span class="en">{{item.value}}&nbsp;({{item.key}})</span>
        </div>
      </div>
    </div>
  </div>
</div>
